import { FormEvent, useEffect, useState } from "react";
import { getTravelPricing, updateTravelPricing, TravelPricing } from "../../../lib/adminApi";
import { useToast } from "../../../components/Toast";

export default function TravelPricingTab() {
  const toast = useToast();
  const [state, setState] = useState<TravelPricing>({ pricePerKmCzk: 8, maxDistanceKm: 100 });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getTravelPricing()
      .then(setState)
      .catch((e) => toast.show("error", e.message))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSaving(true);
    try {
      const saved = await updateTravelPricing(state);
      setState(saved);
      toast.show("success", "Ceník dopravy uložen.");
    } catch (err: any) {
      toast.show("error", err.message ?? "Uložení selhalo.");
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="text-slate-500">Načítám…</div>;

  return (
    <form onSubmit={onSubmit} className="max-w-xl space-y-6">
      <div className="card space-y-4">
        <h2 className="text-base font-semibold text-slate-900">Cena a limit dopravy</h2>

        <label className="block">
          <span className="mb-1 block text-sm font-medium text-slate-700">
            Cena za kilometr <span className="text-red-500">*</span>
          </span>
          <div className="flex items-center gap-2">
            <input
              type="number"
              min={0}
              step={1}
              className="input"
              value={state.pricePerKmCzk}
              onChange={(e) => setState({ ...state, pricePerKmCzk: Number(e.target.value) || 0 })}
              required
            />
            <span className="text-sm text-slate-500">Kč / km</span>
          </div>
          <span className="mt-1 block text-xs text-slate-500">
            Účtuje se klientovi dle vzdálenosti od sídla firmy (Mapy.cz API).
          </span>
        </label>

        <label className="block">
          <span className="mb-1 block text-sm font-medium text-slate-700">
            Maximální vzdálenost <span className="text-red-500">*</span>
          </span>
          <div className="flex items-center gap-2">
            <input
              type="number"
              min={0}
              step={1}
              className="input"
              value={state.maxDistanceKm}
              onChange={(e) => setState({ ...state, maxDistanceKm: Number(e.target.value) || 0 })}
              required
            />
            <span className="text-sm text-slate-500">km</span>
          </div>
          <span className="mt-1 block text-xs text-slate-500">
            Rezervace školek dál než tento limit se odmítne (nebo přepne na manuální schválení — dořešíme).
          </span>
        </label>
      </div>

      <div className="flex justify-end">
        <button type="submit" className="btn-primary" disabled={saving}>
          {saving ? "Ukládám…" : "Uložit ceník"}
        </button>
      </div>
    </form>
  );
}
